import { Stack, Typography } from '@mui/material';

interface Props {
  icon?: React.ReactNode;
  title?: string | React.ReactNode;
  text?: string | React.ReactNode;
  actions?: React.ReactNode;
}

export default function MessageLayout({ icon, title, text, actions }: Props) {
  return (
    <Stack sx={{ gap: 3 }}>
      <Stack sx={{ gap: 2, textAlign: 'center' }}>
        {icon}
        {title && <Typography variant="h5">{title}</Typography>}
        {text && <Typography>{text}</Typography>}
      </Stack>
      {actions}
    </Stack>
  );
}
